import React from 'react';
import Layout from 'components/Layout';
import { Typography } from 'antd';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import './styles.css';

// useRouteError() возвращает unknown. Прежний код читал error.error.message
// напрямую и падал сам (внутри errorElement) на любой ошибке без поля `error`.
const getErrorMessage = (error: unknown): string => {
  if (isRouteErrorResponse(error)) {
    return error.statusText || (typeof error.data === 'string' ? error.data : '');
  }

  if (error instanceof Error) return error.message;
  if (typeof error === 'string') return error;

  return '';
};

const NotFound = () => {
  const error = useRouteError();
  const message = getErrorMessage(error);

  return (
    <Layout>
      <div className="not-found">
        <Typography.Paragraph>Something went wrong...</Typography.Paragraph>
        {!!message && <Typography.Paragraph code>{message}</Typography.Paragraph>}
      </div>
    </Layout>
  );
};

export default NotFound;
